export const PROPERTY_TYPES = ["Commercial", "Residential", "Open Plot", "Industrial"];

export const SUBTYPES = {
  Commercial: ["Office", "Showroom", "Hotel/Restaurant/Resort", "Hospital", "Commercial Flat/Bungalow"],
  Residential: ["Flat", "Bungalow", "Rowhouse", "Penthouse", "House", "Duplex"],
  "Open Plot": ["Land/Plot"],
  Industrial: ["Industrial Shed/Factory", "Warehouse/Godown"],
};

export const LISTING_TYPES = ["Sale", "Rent"];
export const CONDITIONS = ["New", "Resale", "Used", "Unused"];
export const FURNISHING = ["Furnished", "Semi-furnished", "Unfurnished"];
export const FACING = ["North", "South", "East", "West", "North-East", "North-West", "South-East", "South-West"];
export const PROPERTY_STATUSES = ["Available", "Under Negotiation", "Closed", "Archived"];

export const LEAD_PRIORITIES = ["High", "Medium", "Low"];
export const LEAD_STATUSES = ["New", "Follow-Up Required", "Matched", "Closed-Won", "Closed-Lost"];
export const ENQUIRY_FOR = ["Buy", "Rent"];

export const PRIORITY_BADGE = {
  High: "border-red-300 text-red-700 bg-red-50",
  Medium: "border-amber-300 text-amber-800 bg-amber-50",
  Low: "border-emerald-300 text-emerald-800 bg-emerald-50",
};

export const LEAD_STATUS_BADGE = {
  New: "border-sky-300 text-sky-800 bg-sky-50",
  "Follow-Up Required": "border-amber-300 text-amber-800 bg-amber-50",
  Matched: "border-emerald-300 text-emerald-800 bg-emerald-50",
  "Closed-Won": "border-emerald-400 text-emerald-900 bg-emerald-100",
  "Closed-Lost": "border-slate-300 text-slate-600 bg-slate-100",
};

export const DEAL_PHASES = ["Discussion", "MOU", "Paperwork", "Agreement", "Final Payment"];

export const CHECKLIST_ITEMS = [
  { field: "discussion_form_filled", label: "Form filled?" },
  { field: "discussion_brokerage_confirmed", label: "Brokerage confirmation" },
  { field: "discussion_site_visit_done", label: "Site visit" },
  { field: "discussion_photos_videos_taken", label: "Photos and videos taken" },
  { field: "discussion_marketing_done", label: "Marketing done" },
];

export const TIER_BADGE = {
  Excellent: "border-emerald-400 text-emerald-900 bg-emerald-100",
  Good: "border-amber-300 text-amber-800 bg-amber-50",
  Possible: "border-slate-300 text-slate-600 bg-slate-50",
};

export const STATUS_BADGE = {
  Available: "border-emerald-300 text-emerald-800 bg-emerald-50",
  "Under Negotiation": "border-amber-300 text-amber-800 bg-amber-50",
  Closed: "border-slate-300 text-slate-600 bg-slate-50",
  Archived: "border-red-200 text-red-600 bg-red-50",
};
